import {
	FORMAT_HEADING_1_MENU_ITEM,
	FORMAT_HEADING_2_MENU_ITEM,
	FORMAT_HEADING_3_MENU_ITEM,
	FORMAT_HEADING_4_MENU_ITEM,
	FORMAT_HEADING_5_MENU_ITEM,
	FORMAT_HEADING_6_MENU_ITEM,
	FORMAT_PARAGRAPH_MENU_ITEM,
	FORMAT_QUOTE_MENU_ITEM,
	FORMAT_EXPAND_MENU_ITEM,
	FORMAT_LAYOUT_MENU_ITEM,
	FORMAT_PANEL_MENU_ITEM,
	FORMAT_CODE_BLOCK_MENU_ITEM,
	FORMAT_BULLETED_LIST_MENU_ITEM,
	FORMAT_NUMBERED_LIST_MENU_ITEM,
	FORMAT_TASK_LIST_MENU_ITEM,
	FORMAT_MENU_ITEM,
	COPY_BLOCK_MENU_ITEM,
	COPY_LINK_MENU_ITEM,
	MOVE_UP_MENU_ITEM,
	MOVE_DOWN_MENU_ITEM,
	DELETE_MENU_ITEM,
	PRIMARY_MENU_SECTION,
	COPY_MENU_SECTION,
	DELETE_MENU_SECTION,
	MOVE_UP_DOWN_MENU_SECTION,
} from './key';

export const FORMAT_NESTED_MENU_RANK = {
	[FORMAT_HEADING_2_MENU_ITEM.key]: 50,
	[FORMAT_HEADING_3_MENU_ITEM.key]: 100,
	[FORMAT_PARAGRAPH_MENU_ITEM.key]: 150,
	[FORMAT_QUOTE_MENU_ITEM.key]: 200,
	[FORMAT_EXPAND_MENU_ITEM.key]: 250,
	[FORMAT_LAYOUT_MENU_ITEM.key]: 300,
	[FORMAT_PANEL_MENU_ITEM.key]: 350,
	[FORMAT_CODE_BLOCK_MENU_ITEM.key]: 400,
	[FORMAT_BULLETED_LIST_MENU_ITEM.key]: 450,
	[FORMAT_NUMBERED_LIST_MENU_ITEM.key]: 500,
	[FORMAT_TASK_LIST_MENU_ITEM.key]: 550,
	[FORMAT_HEADING_1_MENU_ITEM.key]: 45,
	[FORMAT_HEADING_4_MENU_ITEM.key]: 650,
	[FORMAT_HEADING_5_MENU_ITEM.key]: 700,
	[FORMAT_HEADING_6_MENU_ITEM.key]: 750,
};

export const BLOCK_MENU_SECTION_RANK = {
	[PRIMARY_MENU_SECTION.key]: 100,
	[COPY_MENU_SECTION.key]: 300,
	[MOVE_UP_DOWN_MENU_SECTION.key]: 400,
	[DELETE_MENU_SECTION.key]: 500,
};

export const PRIMARY_MENU_SECTION_RANK = {
	[FORMAT_MENU_ITEM.key]: 50,
};

export const COPY_MENU_SECTION_RANK = {
	[COPY_LINK_MENU_ITEM.key]: 50,
	[COPY_BLOCK_MENU_ITEM.key]: 100,
};

export const MOVE_BLOCK_SECTION_RANK = {
	[MOVE_UP_MENU_ITEM.key]: 50,
	[MOVE_DOWN_MENU_ITEM.key]: 100,
};
export const DELETE_SECTION_RANK = {
	[DELETE_MENU_ITEM.key]: 50,
};
